function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 4,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_11939_10203)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.93 17.5814C21.8152 17.2563 21.6025 16.9748 21.321 16.7758C21.0396 16.5767 20.7033 16.4699 20.3585 16.47H19.0685C18.7005 16.4681 18.3448 16.6027 18.0703 16.8478C17.7958 17.0929 17.6219 17.4311 17.5823 17.797C17.5426 18.1629 17.6401 18.5305 17.8558 18.8287C18.0715 19.1269 18.3901 19.3345 18.75 19.4114L20.7142 19.84C21.1159 19.9279 21.4709 20.1612 21.711 20.4949C21.9511 20.8287 22.0594 21.2394 22.0151 21.6482C21.9709 22.0569 21.7771 22.4349 21.471 22.7095C21.165 22.9841 20.7683 23.1359 20.3571 23.1357H19.2471C18.5214 23.1357 17.9042 22.6729 17.6757 22.0257M19.8028 16.47V14.8029M19.8028 24.8029V23.1371M12.8542 29.2829V25.7114H16.4257",
  stroke: "#365DE6",
  strokeWidth: 1.42857,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.1257 18.2914C29.505 20.3131 29.2022 22.4036 28.2649 24.2346C27.3276 26.0657 25.8088 27.5336 23.947 28.4082C22.0851 29.2827 19.9856 29.5142 17.9779 29.0665C15.9703 28.6187 14.1681 27.517 12.8543 25.9343M10.8743 21.7086C10.495 19.6868 10.7978 17.5964 11.7351 15.7654C12.6724 13.9343 14.1912 12.4663 16.053 11.5918C17.9149 10.7173 20.0144 10.4857 22.0221 10.9335C24.0297 11.3812 25.8319 12.4829 27.1457 14.0657",
  stroke: "#365DE6",
  strokeWidth: 1.42857,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.1456 10.7172V14.2886H23.5742",
  stroke: "#365DE6",
  strokeWidth: 1.42857,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11939_10203"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(10 10)"
})));
const SvgSubscription = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubscription, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/subscription.65772c86.svg";
export { ForwardRef as ReactComponent };